import React from "react";
import { Card, Button } from "react-bootstrap";
import Video from "../../assets/images/video.jpg"
import { FaClock } from "react-icons/fa";
import { Link } from "react-router-dom";

const LessonCard: React.FC = () => {
  return (
    <Card className="p-4 shadow-sm">
      {/* Header Row */}
      <div className=" mb-3">
      Name - <b>Anna Albert</b>
       
       
      </div>
      <p>Certificate Name - <b>From the ground up</b></p>
      

      {/* Video Section */}
      <div className="text-center mb-4">
      <img src={Video} width="665" alt="Logo" className="img-fluid" />
       
      </div>

      {/* Button */}
      <div className="text-center">
        <Link to="/examcompleted" className=" text-decoration-none">
      <button className="btn btn-brand-1 d-block mx-auto">Join Exam</button></Link>
        {/* <Button variant="info" className="px-4 fw-bold text-white">
          START ASSESSMENT
        </Button> */}
      </div>
    </Card>
  );
};

export default LessonCard;